import React, {useEffect, useRef, useState} from 'react';
import Layout from 'components/layouts';
import DeviceTypeFilters from 'components/device-type-filters';
import styles from './styles.module.scss';
import List from './list';
import Dialog from 'components/dialog';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import {useQuery} from 'react-query';
import {IOfferWithRewards} from 'types/offers';
import {APP_PATHS, BREAKPOINTS, QUERY_KEYS} from '../../constants';
import {getOffer} from 'api/offers';
import {DialogRoot} from '@chakra-ui/react';
import {useOffersContext} from 'providers/offers-context';
import ItemDetails from 'components/item-details';
import useWindowSize from 'hooks/useWindowSize';

const Offer: React.FC<any> = () => {
  //got offerId from URL
  const {offerId} = useParams();
  const [isOpen, setOpen] = useState(true);
  const [showButton, setShowButton] = useState(false);
  //added ref to check element scroll position
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  //got previous app url
  const {from} = location.state || {};
  const {setCanFetchList} = useOffersContext();

  //send request
  const {data: resultData = null, isFetching} = useQuery<IOfferWithRewards>(
    [QUERY_KEYS.OFFERS.OFFER],
    async () => {
      return await getOffer(offerId || '', {include_rewards: true, include_offer_details: true});
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !!offerId
    }
  );

  //add listener for page scroll
  const onScroll = () => {
    const element = scrollRef.current;
    if (element) {
      const atBottom = element.scrollHeight - element.scrollTop === element.clientHeight;
      //show button if element are in bottom position
      setShowButton(atBottom);
    }
  };

  useEffect(() => {
    const element = scrollRef.current;
    if (element) {
      //add scroll listener
      element.addEventListener('scroll', onScroll);

      //remove scroll listener on unmount component
      return () => element.removeEventListener('scroll', onScroll);
    }
  }, []);
  const {width} = useWindowSize();

  //render component
  return (
    <Layout>
      <div className={styles.wrapper}>
        <DeviceTypeFilters />
        <List />
        <DialogRoot
          defaultOpen={true}
          scrollBehavior="inside"
          size={width < BREAKPOINTS.MD ? 'full' : 'md'}
          onOpenChange={() => {
            setOpen(!isOpen);
            if (isOpen) {
              if (from === APP_PATHS.OFFERS) {
                setCanFetchList(false);
              }
              //@ts-ignore
              navigate(from ? from : APP_PATHS.BASE, {replace: true});
            }
          }}
          onCloseChange={() => {
            setOpen(false);
          }}
          placement="center"
        >
          <Dialog isOpen={isOpen} ref={scrollRef}>
            <ItemDetails loading={isFetching} data={resultData} showButton={showButton} />
          </Dialog>
        </DialogRoot>
      </div>
    </Layout>
  );
};

export default Offer;
